var map = {
	"./angular.svg": 1856,
	"./cassandra.svg": 6628,
	"./code.svg": 8165,
	"./css.svg": 7099,
	"./django.svg": 6663,
	"./ejs.svg": 1822,
	"./expo.svg": 1538,
	"./express.svg": 7794,
	"./finger.svg": 1457,
	"./flask.svg": 2131,
	"./git.svg": 1046,
	"./github.svg": 6747,
	"./gmail.svg": 7456,
	"./html.svg": 4261,
	"./javascript-extra.svg": 5934,
	"./js.svg": 4691,
	"./left.svg": 6485,
	"./linkedin-white.svg": 8864,
	"./live-link.svg": 9913,
	"./mongodb.svg": 5860,
	"./ms-access.svg": 1057,
	"./ms-excel.svg": 1976,
	"./mysql.svg": 5632,
	"./node.svg": 1250,
	"./npm.svg": 5001,
	"./php.svg": 1634,
	"./postgre-sql.svg": 191,
	"./postman.svg": 72,
	"./python.svg": 5164,
	"./react.svg": 9423,
	"./reactnative.svg": 6422,
	"./right.svg": 888,
	"./spring.svg": 4197,
	"./typescript.svg": 5403,
	"./ussd.svg": 167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8719;